import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { Typography, TextField, Button } from '@mui/material';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import TituloPagina2 from "conten/components/TituloPagina2";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { MobileScreenShare } from "@material-ui/icons";
import { addMessage } from "conten/mensajes/MessagesActions";
import { connect } from "react-redux";
import DispositivosPermitidosApiHelper from "./DispositivosPermitivosApiHelper";

const DispositivosPermitidos = ({ classes, addMessage }) => {
  const [dispositivos, setDispositivos] = useState([]);
  const [nuevoDispositivo, setNuevoDispositivo] = useState({ modelo: "", limite_conexiones: "" });

  const listarDispositivos = async () => {
    try {
      const response = await DispositivosPermitidosApiHelper.listarDispositivosPermitidos();
      setDispositivos(response || []);
    } catch (error) {
      console.error("Error al listar dispositivos permitidos:", error);
      addMessage({
        variant: "danger",
        message: `Error al listar dispositivos permitidos: ${error.message}`,
      });
    }
  };

  const guardarDispositivo = async (dispositivo) => {
    try {
      await DispositivosPermitidosApiHelper.guardarDispositivoPermitido(dispositivo);
      listarDispositivos();
      addMessage({
        variant: "success",
        message: `Dispositivo guardado correctamente.`,
      });
    } catch (error) {
      console.error("Error al guardar dispositivo:", error);
      addMessage({
        variant: "danger",
        message: `Error al guardar dispositivo: ${error.message}`,
      });
    }
  };

  const handleNuevoChange = (field, value) => {
    setNuevoDispositivo({ ...nuevoDispositivo, [field]: value });
  };

  const handleGuardarNuevo = () => {
    if (nuevoDispositivo.modelo && nuevoDispositivo.limite_conexiones) {
      guardarDispositivo(nuevoDispositivo);
      setNuevoDispositivo({ modelo: "", limite_conexiones: "" });
    } else {
      addMessage({
        variant: "warning",
        message: "Por favor completa todos los campos antes de guardar.",
      });
    }
  };

  const handleEditarLimite = (index, value) => {
    const actualizados = [...dispositivos];
    actualizados[index].limite_conexiones = value;
    setDispositivos(actualizados);
  };

  const handleGuardarExistente = (dispositivo) => {
    guardarDispositivo(dispositivo);
  };

  useEffect(() => {
    listarDispositivos();
  }, []);

  return (
    <GridItem xs={12}>
      <Card>
        <CardHeader icon>
          <CardIcon color="info">
            <MobileScreenShare />
          </CardIcon>
          <TituloPagina2 texto="Dispositivos Permitidos" classes={classes} />
        </CardHeader>
        <CardBody>
          {dispositivos.length === 0 ? (
            <Typography>No hay dispositivos registrados actualmente.</Typography>
          ) : (
            <Paper elevation={1}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Modelo</strong></TableCell>
                    <TableCell><strong>Límite de conexiones</strong></TableCell>
                    <TableCell><strong>Acciones</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dispositivos.map((d, index) => (
                    <TableRow key={d.modelo}>
                      <TableCell>{d.modelo}</TableCell>
                      <TableCell>
                        <TextField
                          value={d.limite_conexiones}
                          size="small"
                          type="number"
                          onChange={(e) => handleEditarLimite(index, e.target.value)}
                        />
                      </TableCell>
                      <TableCell>
                        <Button onClick={() => handleGuardarExistente(d)} variant="outlined" color="primary">
                          Guardar
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell>
                      <TextField
                        placeholder="Nuevo modelo"
                        value={nuevoDispositivo.modelo}
                        size="small"
                        fullWidth
                        onChange={(e) => handleNuevoChange("modelo", e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        placeholder="Límite"
                        value={nuevoDispositivo.limite_conexiones}
                        type="number"
                        size="small"
                        fullWidth
                        onChange={(e) => handleNuevoChange("limite_conexiones", e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <Button onClick={handleGuardarNuevo} variant="contained" color="success">
                        Agregar
                      </Button>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          )}
        </CardBody>
      </Card>
    </GridItem>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addMessage: (content) => dispatch(addMessage(content)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    null,
    mapDispatchToProps
  )(DispositivosPermitidos)
);
